import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="container mx-auto px-6 text-center max-w-xl">
        <p className="text-sm font-semibold text-blue-600 mb-3">404</p>
        <h1 className="text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight mb-4">
          Page not found
        </h1>
        <p className="text-lg text-slate-600 mb-8">
          Sorry, we couldn&rsquo;t find that page. It may have moved or no longer exists.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Button asChild>
            <Link to="/">Back to home</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/services">View our services</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
